export default __webpack_public_path__ + "static/media/gold.36d63987.png";